import $axios from '../services/api.js'

const state = () => ({
    quranSurahAyatList: []
})

const mutations = {
    SET_QURAN_SURAH_AYAT_LIST(state, payload) {
        state.quranSurahAyatList = payload
    }
}

const actions = {
    getQuranAyatBySurat({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/quran/list/ayat-by-surat/${payload}`)
                .then((response) => {
                    commit('SET_QURAN_SURAH_AYAT_LIST', response.data.data)
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}